import { CSSProperties } from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';

interface SelectOption {
    id: number | string;
    label: string;
}

interface SelectComponentProps {
    label: string;
    value: number | string;
    onChange: (value: string | number) => void;
    options: SelectOption[];
    styles?: CSSProperties;
    disabled?: boolean;
}

export default function SelectComponent({ label, value, onChange, options, styles, disabled = false }: SelectComponentProps) {
    const handleChange = (event: SelectChangeEvent<number | string>) => {
        const newValue = event.target.value;
        
        if (newValue !== undefined && newValue !== '') {
            onChange(newValue);
        }
    };


    return (
        <FormControl fullWidth sx={styles} disabled={disabled}>
            <InputLabel id={`${label}-label`}>{label}</InputLabel>
            <Select
                labelId={`${label}-label`}
                className='custom-select'
                value={value || ''}
                label={label}
                onChange={handleChange}
                disabled={disabled}
            >
                {options.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
